import Api from '@/util/request'

export const getMenus = () => {
    return Api.getMenus()
}